import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useRef } from "react";
import { apiAxios } from "../../utils/apiAxios";
import { toast } from "react-toastify";
const ContactSupport: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const caseId = location.state?.caseIds;

  const caseIds = location.state?.caseIds;

const [selectedCaseId, setSelectedCaseId] = useState<number | "">(
  Array.isArray(caseIds)
    ? (caseIds.length === 1 ? caseIds[0] : "")
    : caseIds
);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [issueType, setIssueType] = useState("");
  const [priority, setPriority] = useState("Normal");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
 
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!issueType || !description) {
      toast.error("Please fill all required fields");
      return;
    }
    if (file && file.size > 5 * 1024 * 1024) {
      toast.error("File size must be under 5MB");
      return;
    }
    try {
      setLoading(true);
      const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
      const formData = new FormData();
      if (selectedCaseId === "") {
  toast.error("Please select a Case ID");
  setLoading(false);
  return;
}

formData.append("OrderID", selectedCaseId.toString());
      formData.append("IssueType", issueType);
      formData.append("Priority", priority);
      formData.append("Description", description);
      formData.append("ClinicID", selectedClinic.clinicID || "Dentist");
      if (file) {
        formData.append("File", file);
      }

      const res = await apiAxios.post(
        `${API_BASE_URL}/Support/create`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Support ticket created ✅");

      // reset
      setIssueType("");
      setPriority("Normal");
      setDescription("");
      setFile(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; // ✅ clears UI
      }
      // onClose?.();
     navigate("/dentist/DentistContactSupport");
    } catch (err) {
      console.error(err);
      toast.error("Failed to create support ticket");
    } finally {
      setLoading(false);
    }
  };

  if (!caseIds) {
    return (
      <div className="text-center mt-5">
        <h5>No Case Selected</h5>
        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate("/dentist/dashboard")}
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="mt-3">
<h4 className="mb-3">Contact Support</h4>
      <div className="premium-card p-4">
        <form onSubmit={handleSubmit}>
          <div className="row">
<div className="col-md-4 mb-3">
  <label className="form-label">
    {Array.isArray(caseIds) ? "Select Case ID" : "Case ID"}
  </label>

  {Array.isArray(caseIds) ? (
    <select
      className="form-select"
      value={selectedCaseId}
      onChange={(e) => setSelectedCaseId(Number(e.target.value))}
      required
    >
      <option value="">Select Case</option>

      {caseIds.map((id: number) => (
        <option key={id} value={id}>
          {id}
        </option>
      ))}
    </select>
  ) : (
    <input
      className="form-control"
      value={selectedCaseId}
      readOnly
    />
  )}
</div>
            <div className="col-md-4 mb-3">

              <label className="form-label">Issue Type</label>
              <select
                required
                className="form-select"
                value={issueType}
                onChange={(e) => setIssueType(e.target.value)}
              >
                <option value="">Select Issue</option>
                <option>Upload Failed</option>
                <option>Scan Rejected</option>
                <option>Payment Issue</option>
              </select>
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Priority</label>
              <select
                className="form-select"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
              >
                <option>Normal</option>
                <option>High</option>
              </select>
            </div>

            <div className="col-md-4 mb-3">
              <label className="form-label">Attach File</label>
              <input
                type="file"
                className="form-control"
                ref={fileInputRef}
                onChange={(e) =>
                  setFile(e.target.files ? e.target.files[0] : null)
                }
              />
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              rows={4}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>

          <button
            type="button"
            className="btn btn-secondary mx-2"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactSupport;